import { createAction } from '@ngrx/store';

export enum NavActionTypes {
  UserMenuLogout = '[UserMenu] User Menu Logout',
}

export const NavActions = {
  userMenuLogout: createAction(NavActionTypes.UserMenuLogout),
};
